import React from "react";
import { EMAIL_ADDRESS, PHONE_NUMBER } from "../../constants/general";
import { Typography } from "../../UI/Typography";
import { Link } from "../Link";

export const QuestionsHelp = () => (
  <Typography variant="body2" gutterBottom>
    If you have questions about how this tool works, please call us at
    {PHONE_NUMBER} or e-mail <Link href={`mailto:${EMAIL_ADDRESS}`}>{EMAIL_ADDRESS}</Link>
  </Typography>
);
